import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import {useListCompanyAccountsQuery} from "../../apis/companiesApi";
import { useResponsibleHiearchicalList, useAllDepartmentsHeads } from 'hooks/taskHooks';
import {useUserProfileQuery} from "../../apis/authenticationApi";
/**
 * Responsible dropdown
 * @param {*} props 
 * @returns 
 */
export default function TaskResponsibleDropdown(props) {
    const {data: companyUsers, isFetching: isFetchingCompanyUsers} = useListCompanyAccountsQuery();
    
    const {data: userProfile} = useUserProfileQuery();
    const hierarchyUsers = useResponsibleHiearchicalList(props?.parentTask?.responsible || userProfile?.company?.account);
    const allDepartmentHeads = useAllDepartmentsHeads ();
    const taskPossibleUsers = (userProfile?.company?.role === 'CompanyOwner' && !props?.parentTask?.responsible) ? allDepartmentHeads : hierarchyUsers;

    const responsibleItemTemplate = (option) => {
        return option?.registered ? `${option?.firstName} ${option?.lastName}` : option?.email;
    }

    const responsibleValueTemplate = (option) => {
        const user = companyUsers.find(user => user.id === option?.id);
        return user ? (user?.registered ? `${user?.firstName} ${user?.lastName}` : user?.email) : "Select Responsible";
    }


    return (
        <>
            {!isFetchingCompanyUsers && taskPossibleUsers?.length > 0 &&
                <Dropdown valueTemplate={responsibleValueTemplate} itemTemplate={responsibleItemTemplate} 
                        options={taskPossibleUsers} optionLabel="id"  optionValue="id" placeholder="Select Responsible"
                        name={props?.name} id={props?.id} className={props?.className} value={props?.value} onChange={props?.onChange}  />
            }
        </>
    )
}
